<div class="part-search-modal">
  <div class="body">
    <div class="content">
      <form [formGroup]="searchFormGroup" (submit)="submit()" class="search">
        <fip-form>
          <mat-form-field class="search-field">
            <mat-label>Article Number</mat-label>
            <input
              data-cy="article-input-field"
              matInput
              #articleNumber
              placeholder="e.g. 41316072"
              formControlName="articleNumber"
              (blur)="getCompaniesByArticle(articleNumber.value)"
              required
            />
            @if (articleNumberControl?.hasError('required')) {
            <mat-error>Article number is required.</mat-error>
            } @if (articleNumberControl?.hasError('minlength')) {
            <mat-error
              >Article number must be at least 8 characters long.</mat-error
            >
            }
          </mat-form-field>
        </fip-form>

        <fip-form>
          <mat-form-field class="search-field">
            <mat-label>Company</mat-label>
            <mat-select
              data-cy="company-select"
              formControlName="companyCode"
              (valueChange)="searchResult = undefined"
            >
              @for (company of companies$ | async; track company) {
              <mat-option [value]="company.code">{{ company.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </fip-form>

        <button
          mat-flat-button
          color="primary"
          data-cy="article-search-modal-btn"
          (clickEvent)="submit()"
          [disabled]="searchFormGroup.status === 'INVALID' || searchFormGroup.status === 'DISABLED'"
        >
          Search
        </button>

        <!-- <fip-form formType="submit">
            <div
              class="spinner-wrapper inline-block"
              *ngIf="searchLoading$ | async"
              >
              <fip-loading-spinner class="scale-75"></fip-loading-spinner>
            </div>
            <fip-button
              data-cy="article-search-modal-btn"
              *ngIf="(searchLoading$ | async) !== true"
              [loading]="(searchLoading$ | async)!"
              (clickEvent)="submit()"
              label="Search"
              backgroundColor="black"
              textColor="white"
              classes="mt-3 px-3 py-2 sm:ml-3 sm:mt-0 sm:w-auto shadow-sm text-sm"
            ></fip-button>
          </fip-form> -->
      </form>

      @if (((searchLoading$ | async)) === false && searchResult) { @if
      (searchResult.length) {
      <div class="pt-10">
        <a
          [routerLink]="['production', 'stock', $safeNavigationMigration(searchFormGroup.get('articleNumber')?.value), $safeNavigationMigration(searchFormGroup.get('companyCode')?.value) ]"
          class="text-blue-500"
        >
          {{searchResult.length}} items found</a
        >
      </div>
      } @else {
      <fip-data-placeholder
        data-cy="article-search-no-result"
        icon="local_shipping"
        >No results found.</fip-data-placeholder
      >
      } }
    </div>
    <div
      data-cy="serial-numbers-list"
      class="flex-1 self-stretch bg-gray-100 px-4 pb-10 pt-4"
    >
      <h4 class="text-base font-semibold leading-6 text-gray-900">Recent</h4>
      @if ((savedArticles$ | async)?.length === 0) {
      <p class="text-sm text-gray-500">You have no recent search.</p>
      } @else { @for (article of savedArticles$ | async; track article) {
      <button
        class="group mt-2 flex text-sm"
        (click)="loadSavedSearchResult(article.articleNumber, article.companyCode )"
      >
        <p
          class="text-left text-sm font-semibold leading-6 text-gray-900 group-hover:text-gray-500"
        >
          {{ article.articleNumber }}, {{ article.companyName }}
        </p>
      </button>
      } }
    </div>
  </div>
</div>
